module.exports = __webpack_public_path__ + "static/img/extend3.a25573c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/extend3.png
// module id = 17d3
// module chunks = 0